import { render, staticRenderFns } from "./AccreditationItemOM.vue?vue&type=template&id=4abeb5e3&scoped=true&"
import script from "./AccreditationItemOM.vue?vue&type=script&lang=js&"
export * from "./AccreditationItemOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abeb5e3",
  null
  
)

export default component.exports